<ng-container *transloco="let t;">
<div class="drag" cdkDropList (cdkDropListDropped)="drop($event)">
    <div class=" border-bottom CC_CustomBoxListHover" cdkDrag [cdkDragData]="customBoxesData" *ngFor="let customBoxesData of document_type_custom_boxes_data ; let i = index">
            <div class="row">
                <div class="col-xl-6 col-md-6 col-12 pe-0">
                    <h6 class="font-small-3 fw-bold mb-0 customBoxDocfieldTitle pt-25">
                        <span class="customBoxDocfieldSortIcon" placement="auto"
                            [ngbTooltip]="t('Custom box card sort icon tooltip text - (Contract control section) - Sort')"
                            container="body">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                class="icon icon-tabler icon-tabler-menu customColumnSortIcon me-25" width="16"
                                height="16" viewBox="0 0 24 24" stroke-width="1.3" stroke="#2c3e50" fill="none"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M4 8l16 0" />
                                <path d="M4 16l16 0" />
                            </svg>
                        </span>
                        {{ customBoxesData?.meta_data.meta_data_name }}
                    </h6>
                </div>
                <div class="col-xl-6 col-md-6 col-12 ps-0">
                    <div class="editable-section" *ngIf="hiddenValueField === customBoxesData?.meta_data.id">
                        <div class="" *ngIf="customBoxesData?.meta_data.meta_data_type === 'text'">
                            <input
                                #textField
                                type="text"
                                class="form-control form-control-sm p-0 customboxTextFieldValue" 
                                [value]="customBoxesData?.value ?? ''"
                                [placeholder]="t('Input placeholder text (contractControl stepForm) - Add value')"
                                aria-label="add value"
                                (blur)="updateTextFieldValue($event, customBoxesData, i)"
                                (keyup.enter)="updateTextFieldValue($event, customBoxesData, i)"
                            />
                            
                        </div>
                        <div class="form-group groupSelectType mb-0" *ngIf="customBoxesData?.meta_data?.meta_data_type === 'droplist'">
                            <ng-select
                                    #docField
                                    [items]="customBoxesData?.meta_data?.meta_data_option"
                                    [ngModel]="customBoxesData?.value"
                                    [clearable]="false"
                                    bindLabel="name"
                                    bindValue="value"
                                    [searchable]="false"
                                    (change)="updateDroplistValue($event, customBoxesData, i)"
                                    [placeholder]="t('Select option (general) - Select option')"
                                ></ng-select>
                        </div>
                        <div class="custom-control custom-checkbox mb-0" *ngIf="customBoxesData?.meta_data.meta_data_type === 'checkbox'">
                            <input type="checkbox" class="custom-control-input" id="documentfield{{i}}" [ngModel]="+customBoxesData?.value === 1" (change)="updateCheckBoxValue($event, customBoxesData, i)" (blur)="hiddenValueField = 0"/>
                            <label class="custom-control-label" for="documentfield{{i}}"></label>
                        </div>
                        <div class="form-group mb-0" *ngIf="customBoxesData?.meta_data.meta_data_type === 'datepicker'">
                            <input type="text" 
                                    #textField
                                    mwlFlatpickr 
                                    [altInput]="true"
                                    [altFormat]="(false | userTimeZoneFormat) | async"
                                    (change)="updateDatepickerValue($event, customBoxesData, i)"
                                    [value]="customBoxesData?.value ?? ''" 
                                    class="form-control p-0 customboxTextFieldValue"
                                /> 
                        </div>
                    </div>
                    <div *ngIf="hiddenValueField !== customBoxesData?.meta_data.id">
                        <div class="form-group mb-0 d-inline-block"
                             *ngIf="['text', 'droplist', 'datepicker', 'checkbox'].includes(customBoxesData?.meta_data.meta_data_type)"
                             (dblclick)="toggleField(customBoxesData)"
                             placement="auto"
                             container="body"
                             [ngbTooltip]="t('Tooltip text (contractControl stepForm) - Double click to edit')">
                            @if (customBoxesData?.meta_data.meta_data_type === 'checkbox') {
                                @if(customBoxesData?.value === "" || customBoxesData?.value == null){
                                    <p class="font-small-3 mb-0 text-muted pt-25">
                                        {{t('Input placeholder text (contractControl stepForm) - Add value')}}
                                    </p>
                                } @else if(  (customBoxesData?.value) === '1') {
                                    <span class="text-primary font-small-3 fw-bold">
                                        <i class="feather icon-check-square font-medium-3"></i>
                                    </span>
                                } @else if (( customBoxesData?.value) === '0'){
                                    <div class="custom-control custom-checkbox mb-0">
                                        <input type="checkbox" class="custom-control-input" id="documentfield-checkbox{{customBoxesData?.id}}" [value] = "!!customBoxesData?.value" (change)="updateCheckBoxValue($event, customBoxesData, i)" (blur)="hiddenValueField = 0" />
                                        <label class="custom-control-label" for="documentfield-checkbox{{customBoxesData?.id }}"></label>
                                    </div>
                                }
                            } @else {
                                @if(customBoxesData?.value !== "") {
                                    <span class="text-primary customBoxDocvalueTitle pt-25 font-small-3 fw-bold">
                                        @if (customBoxesData?.meta_data.meta_data_type === 'droplist') {
                                            {{ customBoxesData?.meta_data.meta_data_option | showDropListLabel: customBoxesData?.value }}
                                        } @else {
                                            {{ customBoxesData?.value }}
                                        }
                                    </span>
                                } @else {
                                    <span class="text-muted mb-0 font-small-3 pt-25">
                                        {{t('Input placeholder text (contractControl stepForm) - Add value')}}
                                    </span>
                                }
                            }
                        </div>
                    </div>
                    
                </div>
            </div>
    </div>
</div>
</ng-container>
